import { Form } from "@unform/web";
import { useEffect } from "react";

import NexLogo from "Assets/Admin/NexDigital.png";

import { inputMasks } from "Helpers/Format";

import PrimaryButton from "Components/Admin/Buttons/Variants/Primary";
import Input from "Components/Admin/Form/Input";
import Loading from "Components/Admin/Loading";
import TypographyHead from "Components/Global/Typography/Head";

import * as S from "../styles";

const StepLogin = ({ loading, validateLogin, appConfig, loadingConfig }) => {
  useEffect(() => {
    const loginInput = document.querySelector("input[name=login]");

    if (loginInput) loginInput.focus();
  }, []);

  const getInputConfig = (appConfig) => {
    switch (appConfig.login_field) {
      case "email":
        return { type: "email", display_name: "e-mail" };

      case "document":
        return { type: "text", display_name: "CPF", mask: inputMasks.document };

      default:
        return { type: "text", display_name: "login" };
    }
  };

  return (
    <S.Wrapper>
      <S.Row>
        <img src={NexLogo} alt="Nex Logo" />
        <TypographyHead
          dark
          title="Bem vindo de volta"
          description="Preencha seus dados e acesse o painel administrativo"
        />
      </S.Row>
      {loadingConfig ? (
        <S.LoadingWrapper>
          <Loading />
        </S.LoadingWrapper>
      ) : (
        <Form onSubmit={validateLogin}>
          <S.Row>
            <Input
              type={getInputConfig(appConfig).type}
              required
              name="login"
              label="Login"
              placeholder={`Digite seu ${getInputConfig(appConfig).display_name} cadastrado`}
              mask={getInputConfig(appConfig).mask}
            />

            <PrimaryButton text="Continuar" type="submit" disabled={loading} />
          </S.Row>
          <S.BackToSite href="/">Voltar para o site</S.BackToSite>
        </Form>
      )}
    </S.Wrapper>
  );
};

export default StepLogin;
